import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactNotification from 'rc-notification';
import { find, assign } from 'lodash';
import { withTranslate } from 'decorators/withTranslate';
import { notificationDurationInSeconds } from 'config';

const NOTIFICATION_FADE_DURATION_IN_MS = 350;

export const withNotifications =

  /**
   * @param {typeof NotificationStore} StoreClass
   * @param {string} translateContext
   */
  (StoreClass, translateContext = withTranslate.MAIN) =>

    (WrappedComponent) => {

  @withTranslate(translateContext)
  class WithNotifications extends Component {

    static propTypes = {
      t: PropTypes.func
    };

    /** @type {NotificationStore} */
    _store;

    _notification;

    componentDidMount() {
      this._store = StoreClass.getInstance();
      this._store.addChangeListener(this.notify);
      this._notification = ReactNotification.newInstance(withNotifications.baseOptions);
    }

    componentWillUnmount() {
      this._store.removeChangeListener(this.notify);
      StoreClass.destroy();
      this._notification.destroy();
    }

    render() { return <WrappedComponent {...this.props} />; }

    showNotification = (viewData, delay) => {
      window.setTimeout(() => this._notification.notice(viewData), delay);
    }

    hideNotification = (key) => { this._notification.removeNotice(key); }

    notify = () => {
      /** @type {NotificationMetaData} */
      const notificationMetaData = this._store.popNotification();
      if (!notificationMetaData) {
        return;
      }

      const viewData = this.resolveViewData(notificationMetaData);
      if (!viewData) {
        return;
      }

      if (this.isNotificationCurrentlyShown(viewData.key)) {
        this.hideNotification(viewData.key);
        this.showNotification(viewData, NOTIFICATION_FADE_DURATION_IN_MS);
      } else {
        this.showNotification(viewData);
      }

    }

    resolveViewData = (notificationMetaData) => {
      const { t } = this.props;

      /** @type {GetNotificationViewData} */
      const viewDataGetter = this._store.getNotificationViewDataGetter(notificationMetaData.type);
      /** @type {NotificationViewData} */
      const viewData = viewDataGetter(notificationMetaData, t);

      if (!viewData) return viewData;

      return assign({}, withNotifications.baseViewDataParams, viewData);
    }

    isNotificationCurrentlyShown(key) {
      if (!key) {
        return false;
      }

      return Boolean(find(this._notification.component.state.notices, { key }));
    }

  }

  return WithNotifications;

};

withNotifications.baseOptions = {
  style: { right: '0', top: '45px' },
  prefixCls: 'eskimos-notifications',
  maxCount: 3
};

withNotifications.baseViewDataParams = {
  duration: notificationDurationInSeconds
};
